import Vue from 'vue';


import { 
    setItemSessionStorage,
    getItemSessionStorage,
    sponsorsQuickFilter,
    ApiUrls,
    scrollToBlock,
    isUserLoggedIn,
    RedirectsUrls,
    SessionKeys,
    onlyAlphaNumeric
} from '../../helper-functions';

import VueResource from 'vue-resource';
import Multiselect from 'vue-multiselect';
import { Vuelidate } from 'vuelidate';

import {
    mixin as clickaway
} from 'vue-clickaway';

Vue.component('multiselect', Multiselect);
import InlineAds from "../../components/components.inline-ads.vue";
import Spinner from '../../components/components.spinner.vue';
import {SearchSponsors} from '../../mixins/mixin.search-sponsors';

Vue.use(VueResource);
Vue.use(Vuelidate);

Vue.component('sponsors-search', {
    mixins: [SearchSponsors],
    components: {
        Spinner,
        InlineAds,
        'search-sponsors': () => import ("../../components/sponsors/components.search-sponsors.vue"),
        'top-sponsors': () => import ("../../components/sponsors/components.top-sponsors.vue"),
        'v-ratings': () => import ('../../components/components.rating.vue')
    },
    created () {
        // Set all default values.
        this.allReviews.forEach (element => {            
            this.allReplies[`post_${element.id}`] = {
                overallRating: +element.rating || 0,
                rate: {
                    likeCount: element.likeCount || 0,
                    disLikeCount: element.disLikeCount || 0,
                    isLikeLoading: 0,
                    isDisLikeLoading: 0,
                    disableLike: false,
                    disableDisLike: false
                }
            }
        });
    },
    data () {
        return {
            targetedAds: window.immiObj.targetedAds || [],
            allReplies: {},
            allReviews: window.immiObj.reviews || [],
        }
    },
    methods: {
        addLikeDislike (id, type) {
            if(isUserLoggedIn.isLoggedIn) {
                const keyName = 'post_' + id;
                let url, spinTarget;
                switch (type) {
                    case 'dislike':
                        url = ApiUrls.sponsors.postDisLike;
                        this.allReplies[keyName].rate.isDisLikeLoading = true;
                        break;

                    default:
                        // like
                        url = ApiUrls.sponsors.postLike;
                        this.allReplies[keyName].rate.isLikeLoading = true;
                }
                this.$forceUpdate();                
                // spinOpts.color = '#';            
                
                let data = {
                    id: id
                };
                if (window.immiLang.currentLangCode == 'zh') {
                    data.lang = 'zh';
                }
                this.$http.post(url, data).then(response => {
                    const responseBody = response.body;
                    if (responseBody.message == 'success') {
                        switch (type) {
                            case 'dislike':
                                this.allReplies[keyName].rate.disLikeCount += 1;
                                this.allReplies[keyName].rate.isDisLikeLoading = false;
                                this.allReplies[keyName].rate.disableLike = true;
                                break;

                            default:
                                this.allReplies[keyName].rate.likeCount += 1;
                                this.allReplies[keyName].rate.isLikeLoading = false;
                                this.allReplies[keyName].rate.disableDisLike = true;                                
                        }
                    } else {
                        this.allReplies[keyName].rate.isDisLikeLoading = false;
                        this.allReplies[keyName].rate.isLikeLoading = false;
                        this.snackbarType = 'error';
                        this.snackbarMessage = responseBody.error && Array.isArray(responseBody.error) ? responseBody.error[0] : window.immiLang.serverError;
                        this.$refs.snackbar.open();
                    }
                    this.$forceUpdate();
                }, error => {
                    this.snackbarType = 'error';
                    this.snackbarMessage = error?.body || window.immiLang.serverError;
                    this.$refs.snackbar.open();
                    this.allReplies[keyName].rate.isDisLikeLoading = false;
                    this.allReplies[keyName].rate.isLikeLoading = false;
                    this.$forceUpdate();
                })
            } else {
                window.location.href = RedirectsUrls.login;
            }
        }
    }
});

Vue.component('search-results', {
    mixins: [SearchSponsors, clickaway],
    components: {
        Spinner,
        InlineAds,
        'search-sponsors': () => import ("../../components/sponsors/components.search-sponsors.vue"),
        'qf-filter': () => import ("../../components/tracker/quick-filter/components.qf-list.vue"),
        'qf-search': () => import ("../../components/tracker/quick-filter/components.qf-input.vue"),
        'qf-city-state': () => import ("../../components/sponsors/components.qf-city-state.vue"),
        'qf-wage': () => import ("../../components/sponsors/components.qf-wage.vue")
    },
    data () {
        return {
            form: {
                startRow: 1,
                numOfRows: 10,
                sortOrder: 'ASC',
                sortColumn: ''
            },
            viewType: 'table',
            showSearchCriteria: false,
            results: window.immiObj.results || {},
            immiLang: window.immiLang || {},
            qf: sponsorsQuickFilter,
            searchFields: {
                caseStatus: '',
                employerName: '',
                cityState: {city: '', state: ''},
                jobTitle: '',
                wageRate: '',
                sortBy: ''
            },
            caseDetails: {},
            targetedAds: window.immiObj.targetedAds || [],
            formUrl: '',            
        }
    },
    created () {
        if (this.results && this.results.records && Array.isArray(this.results.records)) {
            this.results.records.forEach(element => {
                const key = `post_${element.id}`;
                if (!this.caseDetails.hasOwnProperty(key)) {
                    this.caseDetails[key] = {
                        show: false,
                        fieldValues: []
                    }
                }
            });
        }

        if (window.immiObj.module === 'h1bVisa') {
            this.formUrl = window.immiLang.url.h1bVisaSponsors + window.immiLang.url.searchResults;
        } else {
            this.formUrl = window.immiLang.url.greencardSponsors + window.immiLang.url.searchResults;
        }

        // Set veiw type
        const viewType = getItemSessionStorage(SessionKeys.sponsors.searchResultView);
        if (viewType) this.viewType = viewType;

        this.$root.$on('quick-filter', (val, fieldName) => {
            this.quickFilterSearch(fieldName, val);
        });

        const windowSearchField = window.immiObj?.searchFields || null;        
        if (windowSearchField && windowSearchField.fiscalYear) {
            if (windowSearchField.employerCity) this.searchFields.cityState.city = windowSearchField.employerCity;
            if (windowSearchField.employerState) this.searchFields.cityState.state = windowSearchField.employerState;
            if (windowSearchField.employerName) this.searchFields.employerName = windowSearchField.employerName;
            if (windowSearchField.caseStatus) this.searchFields.caseStatus = windowSearchField.caseStatus;
            if (windowSearchField.jobTitle) this.searchFields.jobTitle = windowSearchField.jobTitle;
            if (windowSearchField.sortColumn) {
                const sortKey = `${windowSearchField.sortColumn}-${windowSearchField.sortOrder || 'ASC'}`;
                let sortInx = null;
                for (let i = 0; i < this.qf.sortBy.fieldValues.length; i++) {
                    const element = this.qf.sortBy.fieldValues[i];
                    if (element.key === sortKey) {
                        sortInx = i;
                        break;
                    }          
                }
                if (sortInx != null) this.searchFields.sortBy = this.qf.sortBy.fieldValues[sortInx].value;
                this.form.currentPage = windowSearchField.startRow;
                this.form.numOfRows = windowSearchField.numOfRows;
            }
            if (windowSearchField.wageRate1 && windowSearchField.wageRate2) {
                this.searchFields.wageRate = `${windowSearchField.wageRate1/1000} to ${windowSearchField.wageRate2/1000}`;
            }

            // set to fieldList
            const allWindowSearchKeys = Object.keys(windowSearchField) || [];
            allWindowSearchKeys.forEach(item => {
                if (windowSearchField[item]) {
                    this.fieldList.push(this.createNsetValue(item, windowSearchField[item]));
                }
            })
        }
    },
    methods: {
        toggleView (typeV) {
            this.viewType = typeV;
            setItemSessionStorage(SessionKeys.sponsors.searchResultView, this.viewType);
        },
        changeRows () {
            this.form.currentPage = 1;
            this.findNclear('startRow');
            this.fieldList.push(this.createNsetValue('startRow', this.form.currentPage));
            this.findNclear('numOfRows');
            this.fieldList.push(this.createNsetValue('numOfRows', this.form.numOfRows));
            this.searchSponsors();
        },
        toggleSearchCriteria () {
            this.showSearchCriteria = !this.showSearchCriteria;
            this.$forceUpdate();
        },
        searchSponsors (reset) {
            let data = {};
            this.fieldList.forEach(item=>{
                data[item.name] = item.value;
            })
            // Vue.nextTick(() => document.querySelector('#searchForm').submit());
            this.$http.post(window.immiObj.module == 'h1bVisa' ? '/h1b-visa-sponsors/search-results/' : '/greencard-sponsors/search-results/', data).then(res=>{
                const responseBody = res.body;
                if (responseBody && responseBody.message) {
                    if (reset) {
                        window.location.href = window.immiObj.module == 'h1bVisa' ? '/h1b-visa-sponsors/' : '/greencard-sponsors/';
                    } else {
                        window.location.href = window.immiObj.module == 'h1bVisa' ? '/h1b-visa-sponsors/search-results/' : '/greencard-sponsors/search-results/';
                    }
                }
            }, error => {
                console.log(error);
            })
            // Vue.nextTick(() => document.querySelector('#searchForm').submit());
        },
        toggleQf (type, event) {    
            Object.keys(this.qf).forEach(item => {
                if (item === type) {
                    this.qf[type].show = !this.qf[type].show;
                } else {
                    this.qf[item].show = false
                }
            });
            const $parent = $(event.currentTarget);
            $parent.next().width(`${$parent.width()+16}px`);
        },
        away() {
            Object.keys(this.qf).forEach(item => this.qf[item].show = false);
        },
        navigateAndSet (url, currentPage) {
            this.form.currentPage = currentPage;
            if (window.immiObj.module === 'h1bVisa') {
                const formUrl = window.immiLang.url.h1bVisaSponsors + window.immiLang.url.searchResults;
                this.formUrl = formUrl;
            } else {
                const formUrl = window.immiLang.url.greencardSponsors + window.immiLang.url.searchResults;
                this.formUrl = formUrl;
            }
            this.findNclear('startRow');
            this.fieldList.push(this.createNsetValue('startRow', currentPage));
            this.searchSponsors();
        },
        getCaseDetails (id, caseNumber) {
            const thisYear = window.immiObj?.results?.sponsorYear || '';
            const key = `post_${id}`;
            if (!this.caseDetails[key].show) {
                this.$http.get(ApiUrls.sponsors.getCaseDetails(caseNumber, thisYear, window.immiObj.module)).then (res => {
                    const responseBody = res.body;                    
                    if (responseBody.message && responseBody.sections && Array.isArray(responseBody.sections)) {
                        this.caseDetails[key].fieldValues = responseBody.sections;
                        this.caseDetails[key].companyLink = responseBody.companyLink;
                        this.caseDetails[key].addressLink = responseBody.addressLink;
                        this.caseDetails[key].show = true;
                        this.$forceUpdate();
                        setTimeout(() => {
                            scrollToBlock(`#tracker_${id} .c-St-List-view`);
                        },150);
                    }
                },error => {
                    console.log(error);
                })
            } else {
                this.caseDetails[key].show = false;
                this.$forceUpdate();
            }            
        },
        quickFilterSearch (filterType, val) {
            let form = {
                startRow: 1,
                numOfRows: 10,
                sortOrder: 'ASC',
                sortColumn: ''
            };

            if (filterType === "cityState") {
                this.findNclear('employerState');
                this.findNclear('employerCity');
                if (typeof val == 'object') {
                    if (val.city) this.fieldList.push(this.createNsetValue('employerCity',val.city));
                    else this.findNclear('employerCity');
                    if (val.state) this.fieldList.push(this.createNsetValue('employerState',val.state));
                    else this.findNclear('employerState');
                }
            } else if (filterType === "wageRate") {
                this.findNclear('wageRate1');
                this.findNclear('wageRate2');
                this.fieldList.push(this.createNsetValue('wageRate1', val.min));
                this.fieldList.push(this.createNsetValue('wageRate2', val.max));
            } else if (filterType === "sortBy") {
                if (val && val.length) {
                    this.findNclear('sortColumn');
                    this.findNclear('sortOrder');
                    let sortInx = null;
                    for (let i = 0; i < this.qf.sortBy.fieldValues.length; i++) {
                        const element = this.qf.sortBy.fieldValues[i];
                        if (element.value === val[0]) {
                            sortInx = i;
                            break;
                        }          
                    }
                    if(sortInx != null) this.fieldList.push(this.createNsetValue('sortColumn', this.qf.sortBy.fieldValues[sortInx].key.split('-')[0]));
                    if(sortInx != null) this.fieldList.push(this.createNsetValue('sortOrder', this.qf.sortBy.fieldValues[sortInx].key.split('-')[1]));
                }
            } else if (val) {
                if (typeof val == "object" && Array.isArray(val)) {
                    val = val.join(',,,,');
                }
                this.findNclear(filterType);
                this.fieldList.push(this.createNsetValue(filterType, val));
            } else {
                this.findNclear(filterType);
            }

            this.findNclear('currentPage');
            this.fieldList.push(this.createNsetValue('currentPage', 1));

            this.changeRows();
        },
        createNsetValue (name,val) {
            return {
                name: name,
                value: val
            };
        },
        findNclear (name) {
            let inxToClear = -1;
            for (let i = 0; i < this.fieldList.length; i++) {
                const element = this.fieldList[i];
                if (element.name === name) {
                    inxToClear = i;
                    break;
                }
            }
            
            if (inxToClear !== -1) this.fieldList.splice(inxToClear, 1);
        },
        resetSearch () {
            this.fieldList = [];
            this.form.currentPage = 1;
            for (const key in this.form) {
                this.fieldList.push(this.createNsetValue(key, this.form[key]));
            }
            this.fieldList.push(this.createNsetValue('fiscalYear', window.immiObj.searchFields.fiscalYear));
            this.searchSponsors(true);
        },
        getLink (postId, sec) {
            const postKey = `post_${postId}`;
            ///employer/employer-address/0&0_Services_Llc/701_87th_St/North_Bergen/NJ/07047/
            return `${this.immiLang.url.employerAddr}${this.caseDetails[postKey].companyLink.replace(/\/employer\//g,'')}${this.caseDetails[postKey].addressLink}`;
        }
    }
});

Vue.component('company-profile', {
    components: {
        'comp-prof-reviews': () => import ("../../view-specific/sponsors/reviews-comp-profile.vue"),
        'comp-prof-jobtitles': () => import ("../../view-specific/sponsors/jobTitle-comp-profile.vue"),
        'comp-prof-appsalaries': () => import ("../../view-specific/sponsors/application-comp-profile.vue"),
        'comp-prof-contacts': () => import ("../../view-specific/sponsors/contact-comp-profile.vue")
    },
    data () {
        return {
            
        }
    }
});

Vue.component('top-sponsors', {
    components: {
        InlineAds,
        'top-sponsors-landing': () => import ("../../components/sponsors/components.top-spns-landing.vue")
    },
    data () {
        return {
            form: {
                startRow: 1,
                numOfRows: 10,
                pagination: true
            },
            topSponsorsList: window.immiObj?.topSponsors?.topSponsorsList || [],
            targetedAds: window.immiObj.targetedAds || [],
            showBy: window.immiObj.showBy,
            formUrl: ''
        }
    },
    created () {
        this.$root.$on('render-top-sponsors', (url, showBy) => {
            this.formUrl = url;
            this.showBy = showBy;
            Vue.nextTick(() => {
                document.getElementById('form').submit();
            });
        });
    }
});

Vue.component('top-sponsors-report', {
    components: {
        InlineAds,
        'top-sponsors-landing': () => import ("../../components/sponsors/components.top-spns-landing.vue")
    },
    data () {
        return {
            form: {
                sortBy: window.immiObj.sortBy || 'Rank Descending',
                filterBy: window.immiObj.filterCriteria || '',
                filterByState: window.immiObj.filterCriteria || '',
                startRow: 1,
                numOfRows: 10,
                calAvgSalary: true,
                category: window.immiObj.category,
                fiscalYear: window.immiObj.fiscalYear,
                showBy: window.immiObj.showBy,
                pagination: true
            },
            formUrl: '',
            isFormSubmitted: false,
            statesList: window.immiObj.statesList || [],
            targetedAds: window.immiObj.targetedAds || [],
            topSponsorsList: window.immiObj?.topSponsors?.topSponsorsList || []
        }
    },
    validations () {
        let validations = {
            form: {
                filterBy: {
                    onlyAlphaNumeric
                }
            }
        }
        return validations;
    },
    created () {
        if (window.immiObj.topSponsors && window.immiObj.topSponsors.topSponsorsList && window.immiObj.topSponsors.topSponsorsList.length && 
            window.immiObj.topSponsors.topSponsorsList[0].noOfRecords)  {
                this.form.numOfRows = window.immiObj.topSponsors.topSponsorsList[0].noOfRecords || 10;
            }
        this.$root.$on('render-top-sponsors', (url, showBy, cat) => {
            if (this.form.category !== cat || this.form.showBy !== showBy) {
                this.form.filterByState = '';
                this.form.filterBy = '';
            }
            this.formUrl = url;
            this.form.showBy = showBy;
            Vue.nextTick(() => {
                document.getElementById('form').submit();
            });
        });
    },
    methods: {
        navigateAndSet (url, currentPage) {
            this.form.startRow = currentPage;
            this.formUrl = this.form.showBy === 'overall' ? ApiUrls.sponsors.topSponsorsByCategory(this.form.category, this.form.fiscalYear, 'company') : ApiUrls.sponsors.topSponsorsByCategory(this.form.category, this.form.fiscalYear, this.form.showBy);
            Vue.nextTick(() => {
                document.getElementById('form').submit();
            });
        },
        updateRecords () {
            this.isFormSubmitted = true;
            this.$v.form.$touch();
            
            this.formUrl = this.form.showBy === 'overall' ? ApiUrls.sponsors.topSponsorsByCategory(this.form.category, this.form.fiscalYear, 'company') : ApiUrls.sponsors.topSponsorsByCategory(this.form.category, this.form.fiscalYear, this.form.showBy);

            if(!this.$v.form.$invalid) {
                Vue.nextTick(() => {
                    document.getElementById('form').submit();
                });
            }
        }
    }
});
